module.exports = __webpack_public_path__ + "img/iepay-payment.800b0590.png";